// extracted by mini-css-extract-plugin
export default {"title":"AddProcedurePage_title__Yvy+b","grid":"AddProcedurePage_grid__rYClQ","policyIcon":"AddProcedurePage_policyIcon__RqWTX"};